/** Etiquetas legibles para estados de laboratorio e imagenología. */
export function estadoLabLabel(estado?: string | null): string {
  switch (estado) {
    case 'SOLICITADA': return 'Solicitada';
    case 'EN_PROCESO': return 'En proceso';
    case 'RESULTADOS_LISTOS': return 'Resultados listos';
    case 'VALIDADA': return 'Validada (firmada)';
    case 'ENTREGADA': return 'Entregada al paciente';
    case 'ANULADA': return 'Anulada';
    default: return estado ?? '—';
  }
}

export function estadoImagenLabel(estado?: string | null): string {
  switch (estado) {
    case 'SOLICITADA': return 'Solicitada';
    case 'EN_ADQUISICION': return 'En adquisición';
    case 'ADQUIRIDA': return 'Imágenes adquiridas';
    case 'INFORMADA': return 'Informe listo';
    case 'ENTREGADA': return 'Entregada al paciente';
    case 'ANULADA': return 'Anulada';
    case 'CONFIRMADA': return 'Confirmada';
    default: return estado ?? '—';
  }
}

export function estadoLabHint(estado?: string | null): string {
  switch (estado) {
    case 'SOLICITADA': return 'Orden creada; pendiente de capturar resultados';
    case 'EN_PROCESO': return 'Laboratorio trabajando la muestra';
    case 'RESULTADOS_LISTOS': return 'Resultados capturados; falta validar/firmar';
    case 'VALIDADA': return 'Firmada por el bioquímico; lista para entregar';
    case 'ENTREGADA': return 'Ya se entregó al paciente o médico';
    default: return '';
  }
}

export function estadoImagenHint(estado?: string | null): string {
  switch (estado) {
    case 'SOLICITADA': return 'Orden creada; pendiente de tomar las imágenes';
    case 'EN_ADQUISICION': return 'Paciente en sala / estudio en curso';
    case 'ADQUIRIDA': return 'Imágenes listas; falta el informe del radiólogo';
    case 'INFORMADA': return 'Informe del radiólogo listo; pendiente de entrega';
    case 'CONFIRMADA': return 'Orden confirmada por imagenología (antes de adquirir)';
    case 'ENTREGADA': return 'Informe entregado al paciente o médico';
    default: return '';
  }
}
